import {
	FeatureFlags,
	Header as HeaderModule,
	Layout,
	Modal,
	UI,
	Utils,
} from 'common';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import isString from 'lodash/isString';
import React, { Component } from 'react';
import PrintSelector from './printSelector/PrintSelector.component';
import RateAdvisorWrapper from './rateAdvisor/RateAdvisorWrapper.component';
import TodoTasks from './todoTasks/TodoTasks.component';
import Features from './videosAndFeatures/Features.component';
import Videos from './videosAndFeatures/Videos.component';

const { Util, Session, Navigation, Analytics: AnalyticsUtils } = Utils;
const { ModalContainer } = Modal;
const { Analytics, Header } = HeaderModule;
const { TopPanel, CenterPanel, RegionType, Viewport } = Layout;
const { Typography } = UI;
const { LaunchDarklyUtil } = FeatureFlags;

class MailView extends Component {
	constructor(props) {
		super(props);

		const showRateAdvisor = Util.isInRoute('rateadvisor');

		this.state = {
			// all in-route views
			showRateAdvisor,

			// `true` if any of in-route is true
			showInRouteView: showRateAdvisor,
		};
	}

	componentDidMount() {
		const { ldClient } = this.props;
		if (ldClient) {
			Session.setFeatureFlags(ldClient.allFlags());
			LaunchDarklyUtil.logIntializeError(ldClient);
			const accountInfo = Session.getAccountInfo();
			AnalyticsUtils.initLogRocket(ldClient, accountInfo);
		}
	}

	/**
	 * Show a specific in-route view when URL contains:
	 *  /rateadvisor - Rate Advisor
	 * @returns {ReactElement}
	 */
	renderInRouteView = () => {
		const { showRateAdvisor } = this.state;

		if (showRateAdvisor) {
			return <RateAdvisorWrapper />;
		}

		return null;
	};

	/**
	 * Render the core main view.
	 * @returns {ReactElement}
	 */
	renderCoreMainView = () => {
		const { signInCallback, showSignInView, modalContext } = this.props;

		// Get first name from session
		const accountInfo = Session.getAccountInfo();
		const { customerDetails = {} } = accountInfo;
		const address = customerDetails.address || {};
		const name = isString(address.name) ? address.name : '';
		const firstName = name.split(' ')[0] || '';

		// Check if account is older than 30 days
		const accountAgeInDays = Util.getAgeOfAccountInDays(
			customerDetails.creationDate
		);
		const shouldShowTodos = accountAgeInDays !== null && accountAgeInDays <= 30;

		return (
			<div className="mail-view">
				<TopPanel region={RegionType.North}>
					<Header
						signInCallback={signInCallback}
						showSignInView={showSignInView}
					/>
					<Analytics />
				</TopPanel>
				<CenterPanel>
					<div className="container">
						{firstName && (
							<div className="section" style={{ marginBottom: '20px' }}>
								<Typography.H1>Welcome, {firstName}!</Typography.H1>
							</div>
						)}
						<div className="section">
							<PrintSelector />
						</div>
						{shouldShowTodos && (
							<div className="section" data-testid="todo-tasks">
								<Typography.H3>To-Do Tasks</Typography.H3>
								<TodoTasks />
							</div>
						)}
						<div className="section" data-testid="video-tutorials">
							<Typography.H3>Watch Video Tutorials</Typography.H3>
							<Videos modalContext={modalContext} />
						</div>
						<div className="section" data-testid="explore-features">
							<Typography.H3>Explore Stamps Features</Typography.H3>
							<Features />
						</div>
					</div>
				</CenterPanel>
			</div>
		);
	};

	render() {
		const { showInRouteView } = this.state;

		const { flags } = this.props;

		// Check LaunchDarkly 'canSeeHomepage' flag and navigate to mail page if true
		if (flags && !flags.canSeeHomepage && !showInRouteView) {
			Navigation.navigateTo('mail');
			return null;
		}

		// render any of in-route views
		if (showInRouteView) {
			return (
				<Viewport>
					<ModalContainer>{this.renderInRouteView()}</ModalContainer>
				</Viewport>
			);
		}

		// render core main view of Account
		return (
			<Viewport
				layout={{
					[RegionType.North]: {
						height: 50,
					},
				}}
			>
				<ModalContainer>{this.renderCoreMainView()}</ModalContainer>
			</Viewport>
		);
	}
}

export default withLDConsumer()(MailView);
